import type { ThemeTokens } from "./types";

/** Neutral portal fallback when the theme API is unavailable. */
export const defaultThemeTokens: ThemeTokens = {
  primary: "#2563EB",
  background: "#F8FAFC",
  text: "#0F172A",
};
